import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

/** Этот компонент редерит прямоугольник, имитирующий блок по его размерам, для более плавного UI
 * во время загрузки элемента
 */
export const SkeletonOfAnySize = ({
  className,
  children
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div className={twMerge('bg-gg_bg rounded-[10px] animate-pulse', className)}>{children}</div>
  );
};

/**
 * Рендерит count скелетонов. Без обертки
 * @param count - количество скелетонов
 * @param className - класснейм ОДНОГО скелетона
 */
export const Skeletons = ({ count = 1, className }: { count?: number; className?: string }) => {
  return (
    <>
      {Array.from(Array(count), (_, index) => (
        <SkeletonOfAnySize className={className} key={index} />
      ))}
    </>
  );
};
